module.exports = __webpack_public_path__ + "static/reward_bg.d329e588.png";